// extracted by mini-css-extract-plugin
module.exports = {"element":"embed-block_element__1iS0I"};